import { Outlet } from 'react-router-dom';
import { useCampaignsEnabled } from '../organisation-settings/organisationSettingsProvider';
import LoadingModal from '../loadingModal';
import useAuth from '../../utils/auth';
import { internalAdminRoles } from '../../types/enums';

export default function CampaignsLayout() {
  const { campaignsEnabled, loading, campaignError } = useCampaignsEnabled();
  const authUser = useAuth();

  if (loading) {
    return <LoadingModal message="...loading" />;
  }
  if ((campaignError && !loading) && !internalAdminRoles.includes(authUser.role)) {
    throw new Error(campaignError);
  }

  return (<Outlet context={{ campaignsEnabled }} />);
}
